import type { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg width={props.width || '1em'} height={props.height || '1em'} fill="none" {...props} viewBox="0 0 17 16">
		<path
			stroke={props.color || 'var(--icon)'}
			strokeMiterlimit={10}
			d="M8.179 1.911c-3.387 0-6.134 2.568-6.134 5.733 0 3.166 2.747 5.734 6.134 5.734 3.386 0 6.133-2.568 6.133-5.734 0-3.165-2.747-5.733-6.133-5.733Z"
		/>
		<path stroke={props.color || 'var(--icon)'} strokeLinecap="round" strokeLinejoin="round" d="M8.178 3.822v4.3h3.067" />
	</svg>
);
export default SvgComponent;
